import type { MemorySliceDescriptor } from "../../shared";
import { getMapInstance } from "../map/mapInstanceRegistry";
import { ephemeralStore } from "../runtime/ephemeralStore";
import { ALL_EPHEMERAL_SLICES } from "../slices/registry";

/**
 * Builds a JSON-serializable snapshot of all ephemeral slices for error reporting.
 *
 * @returns Plain object keyed by slice key; map instance is summarized, not embedded.
 */
export const buildEphemeralSlicesSnapshot = (): Record<string, unknown> => {
    const snapshot: Record<string, unknown> = { "mapInstance": { "mapRegistered": getMapInstance() !== undefined } };

    for ( const slice of ALL_EPHEMERAL_SLICES ) {
        snapshot[slice.key] = ephemeralStore.peek( slice as MemorySliceDescriptor<unknown> );
    }

    return snapshot;
};
